import { IAutoCompleteItem } from '../typings/autoComplete';

export type TaskflowLane = 'records' | 'fee' | 'sec';

export type TaskflowStatus = 'draft' | 'published';

export type TaskflowTaskPriority = 'low' | 'med' | 'high';

export interface TaskflowDueDate {
    manual: boolean;
    manualNote: string;
    mode: 'add' | 'sub';
    days: string;
    basis: 'cal' | 'work';
    relTo: 'matter' | 'member';
    relMatterDate: string;
    relMemberTaskId: string;
    lock: boolean;
    lockDescription: string;
}

export interface TaskflowOutcome {
    question: string;
    options: string[];
}

export interface TaskflowOnCompletionRule {
    id: string;
    fromTaskId: string;
    toStatus: string;
    ifOutcome?: string;
}

export interface TaskflowAccessRule {
    excludeTrigger: boolean;
    excludeTaskIds: string[];
}

export interface TaskflowTask {
    id: string;
    title: string;
    lane: TaskflowLane;
    isGate?: boolean;
    description: string;
    template: string;
    startStatus: string;
    taskType: string;
    assignMode: 'resp' | 'team';
    assignValue?: IAutoCompleteItem;
    allowDelegate?: boolean;
    delegateMode?: 'resp' | 'team';
    delegateValue?: IAutoCompleteItem;
    priority: TaskflowTaskPriority;
    effort: string;
    due: TaskflowDueDate;
    outcome?: TaskflowOutcome;
    onCompletionRules: TaskflowOnCompletionRule[];
    matterStage: string;
    access: TaskflowAccessRule;
}

export interface Taskflow {
    id: string;
    name: string;
    status: TaskflowStatus;
    matterCategory: string[];
    matterType: string[];
    templateOptions: string[];
    matterDateOptions: string[];
    taskOrder: string[];
    tasks: Record<string, TaskflowTask>;
}

export const TASKFLOW_LANE_LABEL: Record<TaskflowLane, string> = {
    records: 'Records',
    fee: 'Fee-Earner',
    sec: 'Sec Team',
};

export const TASKFLOW_TASK_TYPE_OPTIONS = [
    'Client Reporting',
    'Data Entry',
    'Filing',
    'Invoicing',
    'Reminder',
    'Monitoring',
    'Correspondence',
];

export const TASKFLOW_START_STATUS_OPTIONS = ['Not Started', 'Waiting'];

export const TASKFLOW_RESPONSIBILITY_OPTIONS = ['Acting', 'Responsible', 'Assisting'];

export const TASKFLOW_ON_COMPLETION_STATUS_OPTIONS = ['Not Started', 'Waiting', 'Cancelled', 'Complete'];
